export default {
    hCenter: {
        title: 'Help Center',
        titleMore: 'All Questions',
        titleDetail: 'Details',
        c1: 'Tools',
        c2: 'Show Others',
        c3: 'Questions You May Have',
        c4: 'More',
        c5: 'Other Customer Services',
        c6: 'Live CHAT (Telecom service only)',
        c7: 'Contact CMHK',
        c8: 'Appointment Service',
        c9: 'Shop Locations',
        c10: 'Ask a Question',
        c11: 'My Account',
        c12: 'My Bill',
        c13: 'Bill Payment',
        c14: 'Prepaid Card Refill',
        c15: 'Usage Enquiry',
        c16: 'International Roaming',
        c17: 'Offer Zone',
        c18: 'What went wrong?',
        c19: 'Tell us how we could improve',
        c20: 'The information is too long to follow',
        c21: 'It doesn\'t have the information I need',
        c22: 'The solution doesn\'t work',
        c23: 'Other',
        c24: 'Thank you for the feedback',
        c25: 'All Questions',
        c26: 'List',
        c27: 'The information is confusing',
        c28: 'MyLink Points Rewards',
        c29: 'CMHK Shop Address',
        c30: 'Address',
        c31: 'Business Hours',
        f1: 'FPS',
        f2: 'Actual Payment Amount',
        f3: 'This <i class="i">one-time</i> QR code will expire in <i class="i">2 minutes</i>. Please <i class="i">return to MyLink to confirm the payment results</i> after completing the payment on other applications. If you wish to pay again, please go back to the previous page and enter again to <i class="i">refresh the code</i>.',
        f6: 'If payment failed and Coupons/MyLink Points are used, they will be returned to your account after',
        f7: ' 2 hours ',
        f8: 'and can be used again.',
        f9: 'QR code will expire in',
        f10: '',
        f11: '[Instructions] ',
        f12: 'Use This Mobile Device',
        f13: ' to Pay',
        f14: '[Instructions] ',
        f15: 'Use Another Mobile Device',
        f16: ' to Pay',
        f17: '[Instructions] Use This Mobile Device to Pay',
        f18: 'Please take a screenshot or long press to save the QR code',
        f19: 'Open the mobile banking application that supports FPS QR code\n' +
            'merchant payment',
        f20: 'Use the QR code scanning function to import the QR code image\n' +
            'for payment',
        f21: 'Return to MyLink to check the payment success prompt after\n' +
            'successful payment',
        f22: '[Instructions] Use Another Mobile Device to Pay',
        f23: 'Please open the mobile banking application installed on another device that supports FPS merchant QR code payment',
        f24: 'Use the QR code scanning function to scan the FPS QR code for payment',
        f25: 'Return to MyLink to check the payment success prompt after successful payment',
        f26: 'Warning',
        f27: 'The QR code is no longer valid. Please go back to the previous page and enter again to refresh the code. \n' +
            'If Coupons/MyLink Points are used, they will be returned after 2 hours and can be used again.',
        f28: 'Ok',
    }
}



// WEBPACK FOOTER //
// ./src/locale/FPS/en.js